import { inject, Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngxs/store';
import { FeatureFlag } from '@core/enums';
import { AccountState } from '@state/account/state';

@Pipe({
  name: 'hasFeature',
  standalone: true,
})
export class HasFeaturePipe implements PipeTransform {
  private readonly store = inject(Store);

  transform(value: FeatureFlag, param?: 'all' | 'any'): boolean {
    return this.store.selectSnapshot(AccountState.isFeatureEnabled(value));
  }
}
